import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { setElementHidden } from '../utils/elementVisibility';
import { isWhatsappCallsConnectedForRetailer } from '../hooks/calls/resolveCallProvider';

const CALLS_CONNECT_BADGE_ID = 'whatsapp-calls-connect-badge';
// Wrapper (con margen mr-7): ocultarlo evita que deje espacio al estar apagado.
const HEADER_CALLS_WRAPPER_ID = 'whatsapp-calls-header-wrapper';

/**
 * Mantiene sincronizado el header server-rendered de llamadas con el estado de
 * integración (Redux) sin recargar la página:
 * - oculta el badge "conectar" cuando las llamadas ya quedaron conectadas;
 * - muestra el botón de llamadas solo cuando están conectadas.
 *
 * Reacciona al `retailer_info` que se refresca tras conectar (no hace fetch).
 */
const WhatsappCallsNavSyncMC = () => {
  const retailerInfo = useSelector(
    (state) => state.retailerUsersReducer?.retailer_info
  );
  const connectionField = retailerInfo?.whatsapp_calls_connected
    ?? retailerInfo?.voice_platform_calls_connected
    ?? retailerInfo?.whatsapp_calls_feature_enabled;
  const callsConnected = connectionField == null
    ? null
    : isWhatsappCallsConnectedForRetailer(retailerInfo);

  useEffect(() => {
    // No tocar el DOM hasta conocer el estado (evita parpadeo con el ERB inicial).
    if (callsConnected == null) return;

    const enabled = callsConnected === true;
    setElementHidden(CALLS_CONNECT_BADGE_ID, enabled);
    setElementHidden(HEADER_CALLS_WRAPPER_ID, !enabled);
  }, [callsConnected]);

  return null;
};

export default WhatsappCallsNavSyncMC;
